import { Component, ViewEncapsulation, Input, EventEmitter } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import { RecordService } from './../record/record.service';
import { Record } from './record-item.model';

declare var jQuery:any;
declare var Materialize:any;

@Component({
  selector: 'record-item',
  templateUrl: './record-item.component.html',
  styleUrls: ['./record-item.component.scss'],
  providers: [RecordService],
  encapsulation: ViewEncapsulation.None,
  outputs: ['onRemove', 'onRecordSelected']
})
export class RecordItemComponent {
  idPost:number;
  @Input() record:Record;
  onRemove:EventEmitter<any>;
  onRecordSelected:EventEmitter<any>;
  itemForm:FormGroup;

  showEditInput:boolean;

  constructor(private recordService:RecordService, formBuilder:FormBuilder) {
    this.idPost = jQuery('#td-record-box').attr('data-post-id');
    this.onRemove = new EventEmitter();
    this.onRecordSelected = new EventEmitter();

    this.showEditInput = false;

    this.itemForm = formBuilder.group({
      'name': [Validators.required]
    });

    //this.itemForm.valueChanges.subscribe(
    //  (form:any) => {
    //    console.log('form changed to:', form);
    //  }
    //);
  }

  onSubmit(value:any):void {
    if (value.name != this.record.name) {
      this.record.name = value.name;

      this.recordService
        .postUpdateRecord(this.record, this.idPost)
        .subscribe((data:any) => {
            if (data) {
              Materialize.toast(`<p>The record was changed :)</p>`, 3000);
            } else {
              Materialize.toast(`<p>The record wasn't changed :(</p>`, 3000);
            }
            this.showEditInput = false;
          },
          err => {
            Materialize.toast(`<p>${err}</p>`, 3000);
          },
          () => console.log('done')
        );
    } else {
      this.showEditInput = false;
    }
  }

  removeSure():void {
    this.onRecordSelected.emit(this.record);
  }

  remove():void {
    this.onRemove.emit(this.record);
  }

  showInput() {
    this.showEditInput = true;
  }

  setShowTitle(value:Boolean):void {
    this.record.showTitle = value;

    this.recordService
      .postUpdateRecord(this.record, this.idPost)
      .subscribe((data:any) => {
          if (data) {
            Materialize.toast(`<p>The record was changed :)</p>`, 3000);
          } else {
            Materialize.toast(`<p>The record wasn't changed :(</p>`, 3000);
          }
          this.showEditInput = false;
        },
        err => {
          Materialize.toast(`<p>${err}</p>`, 3000);
        },
        () => console.log('done')
      );
  }

  selectText(id:any):void {
    var sel, range;
    var el = document.getElementById('select-' + id); //get element id
    if (window.getSelection && document.createRange) { //Browser compatibility
      sel = window.getSelection();
      if (sel.toString() == '') { //no text selection
        window.setTimeout(function () {
          range = document.createRange(); //range object
          range.selectNodeContents(el); //sets Range
          sel.removeAllRanges(); //remove all ranges from selection
          sel.addRange(range);//add Range to a Selection.
        }, 1);
      }
    }
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./admin/src/app/components/record-item/record-item.component.ts